import { useCallback } from 'react';

const useHomeNavigation = ({ navigate, logout }) => {
  const handleLogout = useCallback(async () => {
    try {
      await logout();
    } catch (err) {
      console.warn('Error al cerrar sesión:', err);
    }

    const ua = (typeof navigator !== 'undefined' && navigator.userAgent) ? navigator.userAgent : '';
    const isIOS = /iPad|iPhone|iPod/i.test(ua);

    if (isIOS) {
      try {
        window.location.replace('/login');
        return;
      } catch {}
    }

    navigate('/login', { replace: true });
  }, [logout, navigate]);

  const handleGoToRooms = useCallback(() => navigate('/rooms'), [navigate]);
  const handleGoToProfile = useCallback(() => navigate('/profile'), [navigate]);
  const handleGoToRoulette = useCallback(() => navigate('/zodiac-roulette'), [navigate]);
  const handleGoToCompatibles = useCallback(() => navigate('/filtered-roulette/compatibles'), [navigate]);
  const handleGoToOpuestos = useCallback(() => navigate('/filtered-roulette/opuestos'), [navigate]);
  const handleGoToSignInfo = useCallback(() => navigate('/sign-info'), [navigate]);
  const handleGoToContacts = useCallback(() => navigate('/contacts'), [navigate]);
  const handleGoToChangePassword = useCallback(() => navigate('/change-password'), [navigate]);
  const handleGoToForum = useCallback(() => navigate('/foro'), [navigate]);
  const handleGoToSupport = useCallback(() => navigate('/support'), [navigate]);
  const handleGoToFeed = useCallback(() => navigate('/feed'), [navigate]);
  const handleGoToZodiacClash = useCallback(() => navigate('/zodiac-clash'), [navigate]);
  const handleGoToZodiacCrush = useCallback(() => navigate('/zodiac-crush'), [navigate]);
  const handleGoToRouletteHub = useCallback(() => navigate('/ruletas'), [navigate]);

  return {
    handleLogout,
    handleGoToRooms,
    handleGoToProfile,
    handleGoToRoulette,
    handleGoToCompatibles,
    handleGoToOpuestos,
    handleGoToSignInfo,
    handleGoToContacts,
    handleGoToChangePassword,
    handleGoToForum,
    handleGoToSupport,
    handleGoToFeed,
    handleGoToZodiacClash,
    handleGoToZodiacCrush,
    handleGoToRouletteHub,
  };
};

export default useHomeNavigation;
